import { createActionTypes } from 'rminwork/es/units';

export default createActionTypes('demo',{
    setName: 'set_name'
})